import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Rating,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { AdminAction } from "../../components/admin";

function DetailField({ label, children }) {
  return (
    <div>
      <label className="block text-xs font-semibold text-zinc-500 uppercase tracking-wide mb-1">
        {label}
      </label>
      <div className="text-zinc-900 break-words">{children}</div>
    </div>
  );
}

function formatCategory(category) {
  if (!category) return "—";
  return String(category)
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

function formatStatus(status) {
  if (!status) return "—";
  return String(status).charAt(0).toUpperCase() + String(status).slice(1);
}

export default function ViewFeedbackDialog({ feedback, open, onClose }) {
  if (!feedback) return null;

  const userName = feedback?.user?.name || feedback?.user?.mobile || "N/A";
  const message = String(feedback?.message || "").trim();
  const createdAt = feedback?.createdAt
    ? new Date(feedback.createdAt).toLocaleString()
    : "—";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { borderRadius: "12px" } }}
      aria-labelledby="feedback-details-title"
    >
      <DialogTitle
        id="feedback-details-title"
        sx={{
          fontWeight: 700,
          pb: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        Feedback Details
        <IconButton size="small" onClick={onClose} aria-label="Close dialog" sx={{ color: "#78716c" }}>
          <Close fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ maxHeight: "60vh" }}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 py-1">
          <DetailField label="User">{userName}</DetailField>
          <DetailField label="Mobile">{feedback?.user?.mobile || "—"}</DetailField>
          <DetailField label="Rating">
            {feedback?.rating ? (
              <div className="flex items-center gap-2">
                <Rating value={Number(feedback.rating)} readOnly size="small" />
                <span className="text-sm text-zinc-600">{feedback.rating}/5</span>
              </div>
            ) : (
              "—"
            )}
          </DetailField>
          {/* <DetailField label="Category">{formatCategory(feedback?.category)}</DetailField> */}
          {/* <DetailField label="Status">{formatStatus(feedback?.status)}</DetailField> */}
          <DetailField label="Submitted">{createdAt}</DetailField>
          <div className="md:col-span-2">
            <DetailField label="Message">
              {message || <span className="text-zinc-400 italic">No message provided</span>}
            </DetailField>
          </div>
          {feedback?.adminResponse ? (
            <div className="md:col-span-2">
              <DetailField label="Admin Response">{feedback.adminResponse}</DetailField>
            </div>
          ) : null}
        </div>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        <AdminAction variant="outline" onClick={onClose}>
          Close
        </AdminAction>
      </DialogActions>
    </Dialog>
  );
}
